import * as React from "react"
import * as Moment from "moment"

import {
    Container,
    Header,
    SemanticICONS,
    GridColumn,
    Grid,
    Button,
    Loader
} from "semantic-ui-react"

import Box from "./Box"
import SocialLink from "./SocialLink"

import "./index.css"

import BlogPost from "modules/frontpage/BlogPost"
import fetchBlogPosts from "modules/frontpage/fetchBlogPosts"


interface State {
    isLoadingBlogPosts: boolean
    blogPosts: BlogPost[]
}

export default class FrontPage extends React.Component<{}, State> {

    constructor(props: any) {
        super(props)

        this.state = {
            isLoadingBlogPosts: false,
            blogPosts: []
        }
    }

    async componentDidMount() {
        await this.loadBlogPosts()
    }

    render() {

        let blogPostItems: any[] = []
        if (!this.state.isLoadingBlogPosts) {
            blogPostItems = this.state.blogPosts.map(it => ({
                link: it.url,
                content: (<span>{it.date.format("YYYY-MM-DD")} • <strong>{it.title}</strong></span>)
            }))
        } else {
            blogPostItems = [{
                content: <Loader active inline />
            }]
        }

        const allBlogItems = [ ...blogPostItems, {
            link: "https://blog.tpersson.io",
            content: <span>Read more ...</span>
        } ]

        return (
            <div className="FrontPage__Main">

                <Container textAlign="center" className="FrontPage__TopSection">
                    <Header
                        as="h1"
                        className="FrontPage__TopSection_Header"
                        content="Tommy Persson"
                        subheader="Building software for humans, machines and those in-between" />
                </Container>

                <div className="FrontPage__MiddleSection">
                    <Container>
                        <Grid columns={2} stackable doubling className="FrontPage__BoxHolder">
                            <Grid.Row>
                                <Grid.Column>
                                    <Box
                                        preface="Follow me on my"
                                        header="Blog"
                                        link="https://blog.tpersson.io"
                                        items={allBlogItems}
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Box
                                        preface="Take a look at my"
                                        header="CV"
                                        link="/cv"
                                        items={[
                                            {
                                                content: <span>Last updated in <b>April 2018</b></span>
                                            },
                                        ]}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </div>

                <div className="FrontPage__BottomSection">
                    <Container style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                        <div className="FrontPage__BottomSection_ContactRow"
                             style={{ alignSelf: "center" }} >
                            <Button color="red" size="huge" as="a" href="mailto:tommy@tpersson.io">Contact</Button>
                        </div>

                        <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
                            <div style={{ flex: 1 }}>
                                <SocialLink icon="github" text="github.com/tommypersson" link="https://github.com/tommypersson" />
                                <SocialLink icon="twitter" text="twitter.com/tpersson127" link="https://twitter.com/tpersson127" />
                                <SocialLink icon="mail" text="tommy@tpersson.io" link="mailto:tommy@tpersson.io" />
                                <SocialLink icon="rss" text="blog.tpersson.io/rss" link="https://blog.tpersson.io/rss" />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "flex-start", alignItems: "flex-end" }} className="FrontPage__BottomSection_ContactColumn">
                                <Button color="red" size="huge" as="a" href="mailto:tommy@tpersson.io">Contact</Button>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        );
    }

    private async loadBlogPosts() {
        this.setState({
            isLoadingBlogPosts: true
        })

        const posts = await fetchBlogPosts()

        this.setState({
            isLoadingBlogPosts: false,
            blogPosts: posts
        })
    }
}




// WEBPACK FOOTER //
// ./src/modules/frontpage/index.tsx